import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";
import { TOAST_SUCCESS } from "../../utils/common.service";
import { data } from "jquery";

export const getSubscriptionApiCall = createAsyncThunk("subscriptionList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: subscriptionList } = await API.getSubscriptionListApi(submitData);
        //console.log("*********************************************",subscriptionList);
        dispatch(setLoader(false))
        return subscriptionList;
    } catch (error) {
        throw error;
    }
});

export const editSubscriptionApiCall = createAsyncThunk("editSubscriptionListData", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        //console.log("000000000000000000000000000000000000",submitData);
        
        const { data: editSubscriptionData, code, message } = await API.updateSubscriptionApi(submitData);
        if (code === '1') {
            //TOAST_SUCCESS(message);
        }
        dispatch(setLoader(false))
        return { data: editSubscriptionData, code, message };
    } catch (error) {
        throw error;
    }
});

const initialState = {
    subscriptionList: {
        data: [],
        error: null,
    },
    editSubscriptionData: {
        data: null,
        code: '',
        message: '',
        error: null,
    },
};

const SubscriptionSlice = createSlice({
    name: "CLIENT",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSubscriptionApiCall.fulfilled, (state, action) => {
                state.subscriptionList.data = action.payload;
            })
            .addCase(getSubscriptionApiCall.rejected, (state, action) => {
                state.subscriptionList.error = action.error.message;
            })
            .addCase(editSubscriptionApiCall.fulfilled, (state, action) => {
                const { message, code, data } = action.payload;
                state.editSubscriptionData.data = data;
                state.editSubscriptionData.message = message;
                state.editSubscriptionData.code = code;
            })
            .addCase(editSubscriptionApiCall.rejected, (state, action) => {
                state.editSubscriptionData.error = action.error.message;
            });
    },
});

export default SubscriptionSlice.reducer;